module.exports = __webpack_public_path__ + "img/Dantam Hair 52.c8cb8262.jpg";